import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
    process.env.REACT_APP_SUPABASE_URL,
    process.env.REACT_APP_SUPABASE_KEY,
    {
        auth: {
            storage: window.sessionStorage, // session clears when the tab/window closes
            persistSession: true,
            autoRefreshToken: true,
        },
    }
);

export default supabase;